module.exports = __webpack_public_path__ + "media/images/flower_green-055130af523eb7f3d4d194a88feab2de.svg";